import { makeStyles } from 'tss-react/mui';

export const useOpenChatButtonStyles = makeStyles()((theme) => ({
  anchorOriginTopRightRectangle: {
    [theme.breakpoints.down('sm')]: {
      top: '5px',
    },
  },
}));
